export const CATEGORIES = [
  "Motors", "Jobs", "House & DIY", "Farming",
  "Lettings", "Property for Sale", "Clothes & Fashion", "Sports & Leisure",
];

// "House & DIY" -> "house-diy", "Property for Sale" -> "property-for-sale"
export const categoryToSlug = (c) =>
  c.toLowerCase().replace(/&/g, " ").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const slugToCategory = (slug) =>
  CATEGORIES.find((c) => categoryToSlug(c) === slug) || null;

export const categoryPath = (c) => `/category/${categoryToSlug(c)}`;
